import firebase from 'firebase/app'
import 'firebase/firestore'

// Initialize Firebase
var config = {
apiKey: "AIzaSyAo8sVz-maTxl65ivbXB3I9n_MJfTG2HGQ",
authDomain: "todoify-6c5c5.firebaseapp.com",
databaseURL: "https://todoify-6c5c5.firebaseio.com",
projectId: "todoify-6c5c5",
storageBucket: "todoify-6c5c5.appspot.com",
messagingSenderId: "482487388528"
};
firebase.initializeApp(config);
const db = firebase.firestore();

//db.settings({timestampsInSnapshots:true});
export default db;